import { UploadError } from '../../errors';

export class AzureInvalidSignatureParamsError extends UploadError {}
